<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const fcstHist = ref()
const historyList = ref([])

const getWx = (el) => {
  const url = new URL('https://site.weathernews.jp/lba/wxdata/api_data_ss1')
  url.searchParams.set('lat', el.lat)
  url.searchParams.set('lon', el.lon)
  return axios.get(url.toString())
    .then((res) => {
      const json = res.data
      const elm = {}
      elm.telop = `https://gvs.weathernews.jp/onebox/img/wxicon/header_wIcon_${json.mrf[0].WX}@2x.webp`
      elm.high = json.mrf[0].MAXT
      elm.low = json.mrf[0].MINT
      elm.url = el.url
      elm.cityname = el.cityname
      return elm
    })
}

const historyClose = (id) => {
  fcstHist.value.splice(id, 1)
  historyList.value.splice(id, 1)
  localStorage.setItem('wx_history', JSON.stringify(historyList.value))
}

onMounted(() => {
  if (navigator.cookieEnabled) {
    if (typeof window.localStorage !== 'undefined') {
      historyList.value = JSON.parse(localStorage.getItem('wx_history'))
      if (historyList.value) {
        Promise.all(historyList.value.map((history) => getWx(history))).then((list) => {
          fcstHist.value = list
        })
      }
    }
  }
})

</script>

<template>
  <div
    class="history"
  >
    <div
      v-for="(item, index) in fcstHist"
      :key="index"
      class="historyItem"
    >
      <a
        :href="item.url + '?fm=header'"
        class="link"
      >
        <figure class="image">
          <img
            :src="item.telop"
            alt=""
            width="38px"
            height="38px"
          >
        </figure>
        <div class="content">
          <p class="text">{{ item.cityname }}</p>
          <div class="temp">
            <span class="high">{{ item.high }}</span>/<span class="low">{{ item.low }}</span>
          </div>
        </div>
      </a>
      <p
        class="close"
        @click="historyClose(index)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.history {
  display: flex;
  flex: 1;
  gap: 5px;
  padding: 4px 10px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .historyItem {
    position: relative;
    min-width: 122px;
    border: solid 1px #c0c0c0;
    background-color: #fff;
    border-radius: 4px;
    .link {
      display: flex;
      align-items: center;
      padding: 2px 4px;
      gap: 5px;
    }
    .image {
      width: 30px;
      height: 30px;
      border-radius: 3px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .text {
      display: inline-block;
      width: 77px;
      font-size: 12px;
      font-weight: bold;
      line-height: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    .temp {
      display: flex;
      gap: 3px;
      color: #101010;
      font-size: 12px;
      font-weight: bold;
      line-height: 12px;
      .high {
        color: #f64d00;
      }
      .low {
        color: #0075f3;
      }
    }
    .close {
      position: absolute;
      bottom: 2px;
      right: 4px;
      width: 12px;
      height: 12px;
      background-image: url('https://gvs.weathernews.jp/onebox/img/icon/icon_close.svg');
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      z-index: 5;
    }
  }
  @media screen and (min-width: 830px) {
    padding: 4px;
    .historyItem {
      min-width: 140px;
      .link {
        padding: 2px;
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
      .image {
        width: 38px;
        height: 38px;
      }
      .text {
        width: 90px;
        font-size: 13px;
      }
      .close {
        right: 2px;
        transition: opacity .2s ease-in-out, transform .2s ease-in-out;
        &:hover {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
}
</style>
